import React from "react";
import { useSelector } from "react-redux";
import { oidcSelector } from "../../selectors/oidcSelectors";
import { Link } from "react-router-dom";
import routesConfig from "../../routes/routes-config";
import { HomepageButton } from "../../components/common";
import { Row, Col, Container } from "reactstrap";
import "./home.css";

const HomePage = () => {
  const oidc = useSelector(oidcSelector);

  function greetingMessage() {
    var now = new Date();
    const hours = now.getHours();
    var message = "Good evening";
    if (hours >= 8 && hours < 10) {
      message = "Good morning";
    } else if (hours >= 10 && hours < 17) {
      message = "Good afternoon";
    }
    return message;
  }

  return (
    <React.Fragment>
      <Container
        className="home-page-container col-sm-12 col-lg-8 col-xl-7 col-xxl-4 "
        tabIndex="0"
      >
        {!oidc.isLoadingUser && oidc.user && (
          <h1 className="home-page-greeting">
            {greetingMessage()},&nbsp;
            {oidc.user.profile.name}
          </h1>
        )}
        <h3 className="home-page-sub-greeting">
          Let’s do some compliance today!{" "}
        </h3>
        <br />
        <br />

        <Row className="text-center">
          <Col lg={4}>
            <Link
              className="nav-link"
              to={routesConfig.monitoringQueueEntriesPage.path}
            >
              <HomepageButton
                className="home-page-dark-blue-button"
                text="Monitoring Queue"
              />
            </Link>
          </Col>
          <Col lg={4}>
            <Link
              className="nav-link"
              to={routesConfig.watchListEntriesPage.path}
            >
              <HomepageButton
                className="home-page-dark-blue-button"
                text="Manual Search"
              />
            </Link>
          </Col>
          <Col lg={4}>
            <Link
              className="nav-link"
              to={routesConfig.watchListEntriesByWatchListPage.path}
            >
              <HomepageButton
                className="home-page-dark-blue-button"
                text="Watchlists"
              />
            </Link>
          </Col>
        </Row>
        <Row className="text-center">
          <Col lg={4}>
            <Link
              className="nav-link"
              to={routesConfig.singleClientReport.path}
            >
              <HomepageButton
                className="home-page-green-button"
                text="Single Client"
              />
            </Link>
          </Col>
          <Col lg={4}>
            <Link
              className="nav-link"
              to={routesConfig.multipleClientsReport.path}
            >
              <HomepageButton
                className="home-page-green-button"
                text="Multiple clients"
              />
            </Link>
          </Col>
          <Col lg={4}>
            <Link className="nav-link" to={routesConfig.profileDetails.path}>
              <HomepageButton
                className="home-page-green-button"
                text="Client Profile"
              />
            </Link>
          </Col>
        </Row>
      </Container>
      <div className="home-page-background-logo" />
    </React.Fragment>
  );
};
export default HomePage;



// WEBPACK FOOTER //
// ./src/features/home/home.jsx